import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import ActiveHelper from '../../../components/common/activeHelper';
import { deviceWidth } from '../../../helpers/Utils';
import BusyTimingsLogs from './components/busyTimingsLogs';
import Locations from './components/locations';
import ManageBusyTimings from './components/manageBusyTimings';
import Timings from './components/timings';
import WashersFilter from './components/washersFilter';
import WasherWallet from './components/washerWallet';
import Services from './services';

const Workers = ({ match }) => {
  const { activeItem } = useSelector(state => state.activeItem);
  const search = useSelector(state => state.settings.search) || '';
  const { washers, provider } = useSelector(state => state.providers);
  const [selectedWasher, setSelectedWasher] = useState(null);
  const [selectedWasherForManagement, setSelectedWasherForManagement] = useState(null);
  const [filteredWashers, setFilteredWashers] = useState([]);
  const [intermediateWashers, setIntermediateWashers] = useState([]);
  const [filters, setFilters] = useState({
    washersStatus: 'all',
    selectedProvider: false
  });

  // Apply custom filters first (status, provider)
  useEffect(() => {
    let filtered = Object.values(washers || {})?.filter(washer => {
      const isActive = filters.washersStatus && filters.washersStatus !== 'all'
        ? (filters.washersStatus === 'active' ? washer.active : !washer?.active)
        : true;

      const isProviderMatch = filters.selectedProvider ? (washer?.sp_id === filters.selectedProvider?.key) : true;

      return isActive && isProviderMatch;
    });
    setIntermediateWashers(filtered);
  }, [washers, filters]);

  // Apply search filter on top of custom filters
  useEffect(() => {
    let filtered = intermediateWashers;

    // Search filter - search by name, arabic name, phone number, and provider name
    if (search && search.trim()) {
      const searchLower = search.toLowerCase().trim();
      filtered = filtered.filter(washer => {
        const nameMatch = (washer?.name || '').toLowerCase().includes(searchLower);
        const nameArMatch = (washer?.name_ar || '').toLowerCase().includes(searchLower);
        const phoneMatch = (washer?.phoneNumber || '').replaceAll(' ', '').toLowerCase().includes(searchLower);
        const providerMatch = provider?.[washer?.sp_id]?.name?.toLowerCase().includes(searchLower);
        return nameMatch || nameArMatch || phoneMatch || providerMatch;
      });
    }

    setFilteredWashers(filtered);
  }, [intermediateWashers, search, provider]);


  const elements = useMemo(() => {

    return [{
      key: 'generalInfo',
      title: 'Worker Information',
      hideTitle: true,
      data: [
        { key: 'sp_id', title: 'Service Provider', width: '10', type: 'select', data: Object.values(provider || {})?.map(rec => { return { ...rec, name: rec.name, key: rec.key, id: rec.key } }) || [], selected: 'providers', },
        { type: 'subheader', title: 'General Information', hideTitle: true },
        { key: 'profile_image', title: 'Worker Picture', width: '10', type: 'picture', dimensions: { width: 720, height: 1080 } },
        { key: 'name', title: 'Name', width: '5', type: 'text' },
        { key: 'name_ar', title: 'Arabic Name', width: '5', type: 'text' },

        { type: 'subheader', title: 'Account Information', hideTitle: true },
        { key: 'phoneNumber', title: 'Number', width: '10', type: 'phoneNumber', showChangeNumber: true },
      ]
    },

    {
      key: 'activeServices', title: 'Services',
      type: 'standalone',
      isCollection: false,
      data: <Services
        selectedProvider={provider?.[activeItem?.general?.sp_id]}
        activeServices={JSON.parse(JSON.stringify(activeItem?.general?.activeServices || {}))}
        servicesDescs={JSON.parse(JSON.stringify(activeItem?.general?.servicesDescs || {}))} />
    },
    {
      key: 'timings',
      title: 'Timings',
      type: 'standalone',
      isCollection: false,
      data: <Timings
        defultSettings={provider?.[activeItem?.general?.sp_id]?.defultSettings} />
    },
    {
      key: 'locations',
      title: 'Serving Areas',
      type: 'standalone',
      isCollection: true,
      data: <Locations />
    },
    {
      key: 'wallet',
      title: 'Worker Wallet',
      type: 'standalone',
      isCollection: true,
      data: <WasherWallet />
    }

    ];
  }, [activeItem?.general, provider]);

  const tableColumns = useMemo(() => {
    return [
      { Header: "Status", accessor: "active", width: 120, type: 'switch' },
      { Header: "", accessor: "profile_image", width: deviceWidth() === 'desktop' ? 150 : 80, type: 'img' },
      { Header: "Name", accessor: "name", width: 160, type: 'label' },
      { Header: "Arabic Name", accessor: "name_ar", width: 160, type: 'label' },
      { Header: "Service Provider", accessor: "sp_id", width: 160, type: 'provider' },
      { Header: "Number", accessor: "phoneNumber", width: 160, type: 'label' },
      { Header: 'Last Updated', accessor: 'updated', type: 'date', width: 160, show: deviceWidth() === 'desktop' },
      {
        Header: 'Busy Timings', accessor: 'busyTimings', type: 'busyTimings',
        func: (original, type) => {
          switch (type) {
            case 'busyTimingsLogs':
              setSelectedWasher(original)
              break;
            case 'busyTimingsManagement':
              setSelectedWasherForManagement(original)
              break;
            default:
              break;
          }
        }
      },
    ];
  }, []);


  // Filter component
  const filterComponent = useMemo(() => (
    <WashersFilter
      filters={filters}
      onFiltersChange={(filteredData) => setFilters(filteredData)}
    />
  ), [filters]);

  return (
    <div>
      <Switch>
        <Route path={`${match.url}/`} render={() => {
          return (
            <>
              <ActiveHelper
                data={filteredWashers || []}
                title="Workers"
                selected='washers'
                elements={elements}
                tableColumns={tableColumns}
                defaultSorting="active"
                // exportCSV={handleExportProviders}
                filterComponent={filterComponent}
                showCreateButton={true}
              />
              {selectedWasher && <BusyTimingsLogs washer={selectedWasher} dismiss={() => setSelectedWasher(null)} />}
              {selectedWasherForManagement && <ManageBusyTimings washer={selectedWasherForManagement} dismiss={() => setSelectedWasherForManagement(null)} />}
            </>
          )
        }} />
        <Redirect to="/error" />
      </Switch>
    </div>
  )

};
export default Workers;
